// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1___7807a88acfa845a9fae","cls2":"PaperContainer-cls2__d4a20e059741ab709b44 PaperContainer-cls1___7807a88acfa845a9fae"};